import React, {useState} from 'react';
import {observer} from "mobx-react";
import {GamesSuggestionsWidgetAsync} from "../../../widgets/games-suggestions-widget/components/games-suggestions-widget.async";
import styles from "../styles/game-center-container.module.scss"
import classNames from "classnames";

export const GameCenterContainerGamesSuggestions = observer(({controller}) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {gameId, matchupId} = state;

  const [isWidgetVisible, setWidgetVisible] = useState(gameId && isSmallView)

  const gamesSuggestionsProps = {
    gameId,
    matchupId,
    onWidgetVisible: (isVisible) => {
      setWidgetVisible(isVisible)
    }
  }

  return <div className={classNames(styles.game_suggestions_container, {[styles.game_suggestions_hidden]: !isWidgetVisible})}>
    {
      isWidgetVisible ? <GamesSuggestionsWidgetAsync {...gamesSuggestionsProps}/> : null
    }
  </div>

});
